/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCustomerBeneficiariesCommand } from '../../models/create-customer-beneficiaries-command';
import { CustomerBeneficiariesDtoApiResponse } from '../../models/customer-beneficiaries-dto-api-response';

export interface CreateCustomerBeneficiaryAsync$Plain$Params {
  id: number;
      body?: CreateCustomerBeneficiariesCommand
}

export function createCustomerBeneficiaryAsync$Plain(http: HttpClient, rootUrl: string, params: CreateCustomerBeneficiaryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createCustomerBeneficiaryAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>;
    })
  );
}

createCustomerBeneficiaryAsync$Plain.PATH = '/api/customer/{id}/beneficiary';
